import { useLongfansMock } from "../../global/GlobalMock";
import { post } from "../../utils/Backend";
import { myNotesMocks } from "./MyNotesMock";
import type {
  MyNotesListParam,
  MyNotesListResult,
  MyNotesStatsParam,
  MyNotesStatsResult,
} from "./MyNotesType";

const mockMyNotes = useLongfansMock && false;

const BASE = "/lark/app/userStockNote";

export const MyNotesApi = {
  async listNotes(param: MyNotesListParam): Promise<MyNotesListResult | null> {
    if (mockMyNotes) {
      return myNotesMocks.listNotes(param);
    }
    const r = await post<MyNotesListParam, MyNotesListResult>(
      `${BASE}/listNotes`,
      {
        spaceId: param.spaceId,
        stockCode: param.stockCode?.trim() || undefined,
        validityFilter: param.validityFilter ?? "all",
        pageNum: param.pageNum ?? 1,
        pageSize: param.pageSize ?? 10,
      },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async queryNoteStats(param: MyNotesStatsParam): Promise<MyNotesStatsResult | null> {
    if (mockMyNotes) {
      return myNotesMocks.queryNoteStats(param);
    }
    const r = await post<MyNotesStatsParam, MyNotesStatsResult>(
      `${BASE}/queryNoteStats`,
      {
        spaceId: param.spaceId,
        stockCode: param.stockCode?.trim() || undefined,
      },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },
};
